import { fetchWrapper } from '../Helpers';

const baseUrl = `${process.env.REACT_APP_API_URL}/advtoken`;

export const tokenService = {
  getTokenData,
  getTokenTxn
};
function getTokenData(params) {
  return fetchWrapper.get(baseUrl + '/gettokendata');
}
function getTokenTxn(options) {
  let filterString = '';
  if (options.filter) {
    filterString = options.filter;
  }
  if (options.page !== undefined) {
    filterString = getAllPaging(options, filterString);
  }
  const url =
    filterString.length > 0
      ? `${baseUrl}/tokenhistory?${filterString}`
      : `${baseUrl}/tokenhistory`;
  return fetchWrapper.get(url);
  // return fetchWrapper.get(baseUrl + '/tokenhistory');
}
function getAllPaging(options, filterString) {
  filterString += filterString.length > 0 ? `&` : '';
  filterString += `page[number]=${options.page}`;
  if (options.pageSize) {
    filterString += filterString.length > 0 ? `&` : '';
    filterString += `page[size]=${options.pageSize}`;
  }
  if (options.fileType) {
    filterString += filterString.length > 0 ? `&` : '';
    filterString += `page[filetype]=${options.fileType}`;
  }
  return filterString;
}